/*  ========================================================================
    # Sections - Team Opinions - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import TeamOpinions from './TeamOpinions';

const containers = document.querySelectorAll('div[data-react-app="TeamOpinions"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = containers[i].attributes['data-guid']?.value;
  const props = window.reactProps[containerGuid];

  createRoot(containers[i]).render(<TeamOpinions {...props} />);
}
